import { Col, Row, Spinner2, Text } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { NavBar } from './components';

const Admin = (props) => {
  const [fetching, setFetching] = useState(true),
    isMobile = useSelector((state) => state.appState.isMobile),
    admin = useSelector((state) => state.admin),
    user = useSelector((state) => state.user),
    dispatch = useDispatch();

  const isP4PAdmin = !!user?.admin;

  useEffect(() => {
    // /admin/initial is P4P-admin-only. Team-admin channel owners skip it; their
    // screen (QuickQuiz) doesn't depend on the `admin` redux slice.
    if (isP4PAdmin) {
      getInitialData();
    } else {
      setFetching(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isP4PAdmin]);

  async function getInitialData() {
    const res = await Api.get('/admin/initial');
    if (!res) return;

    dispatch({
      type: 'SET_ADMIN',
      payload: res
    });

    setFetching(false);
  }

  const showSpinner = isP4PAdmin ? !admin || fetching : fetching;

  return (
    <Col start ht="100%">
      {isMobile ? (
        <Col wid="100%" centerAll>
          <Text h3>Only available on desktop.</Text>
        </Col>
      ) : (
        <Row wid="100%">
          <NavBar />

          {showSpinner ? (
            <Col ht="100vh" centerAll>
              <Spinner2 />
            </Col>
          ) : (
            <Col marg="0 0 0 190px" wid="100%" minHt="100vh" style={{ overflow: 'scroll' }}>
              <Outlet />
            </Col>
          )}
        </Row>
      )}
    </Col>
  );
};

export default Admin;
